// ModalFooter.js
import React from 'react';
import { View, StyleSheet, ViewStyle, StyleProp } from 'react-native';

interface ModalFooterProps {
  children?: React.ReactNode;
  style?: StyleProp<ViewStyle>;
}

const ModalFooter = ({ children, style }: ModalFooterProps) => {
  return (
    <View style={[styles.modalFooter, style]}>
      {children}
    </View>
  );
};

const styles = StyleSheet.create({
  modalFooter: {
    alignItems: 'flex-end',
    padding: 16,
  },
});

export default ModalFooter;
